module.exports = __webpack_public_path__ + "img/logo4.7a482b93.png";